export default function SolutionPanelData() {
    return {
      title: "Need a budget sensitive solution?",
      paragraph: "Get up to $150k in Securian whole life insurance with our instant decision E-Application.",
      href: "/landing/permanent",
   }
 }


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/WholeLife/SolutionPanelData.js